import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Button, Input, Select, DatePicker, message } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import {
  DownCircleOutlined,
  FilterOutlined,
  FilterTwoTone,
  ReloadOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";
import { useSelectOptions } from "../storeDivisionSelect";

export const FilterMode = () => {
  const { getDepartment, department, getCategory, category } =
    useVendorMasterStore();
  const { getExpiryDiscount } = useNearToExpiryStore();
  const [filters, setFilters] = useState({
    divisionCode: 0,
    departmentCode: 0,
  });

  const [errors, setErrors] = useState({});
  useEffect(() => {
    getCategory();
    getExpiryDiscount(filters)
  }, []);
  const departmentOptions = useSelectOptions(department, {
    labelKey: "DepartmentName",
    valueKey: "Department",
    allLabel: "All",
  });
  const divisionOptions = useSelectOptions(category, {
    labelKey: "DivisionName",
    valueKey: "Division",
    allLabel: "All",
  });
  const handleDivisionChange = (value) => {
    setFilters({
      divisionCode: value,
      departmentCode: null,
    });

    setErrors({});
    if (value) getDepartment(value);
  };

  const handleSearch = async () => {
    const newErrors = {};

    if (filters.divisionCode===null || filters.divisionCode===undefined) {
      newErrors.divisionCode = "Division is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      await getExpiryDiscount(filters);
      // message.success("Data fetched successfully");
    } catch (error) {
      console.error(error.message || "Something went wrong");
    }
  };
  return (
    <>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Divison"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            value={filters.divisionCode}
            options={divisionOptions}
            onChange={handleDivisionChange}
          />
          {errors?.divisionCode && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.divisionCode}
            </span>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Department"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            value={filters.departmentCode}
            options={departmentOptions}
            onChange={(value) =>
              setFilters((prev) => ({
                ...prev,
                departmentCode: value,
              }))
            }
          />
          
        </Col>

        <Col xl={1} style={{ textAlign: "center", marginTop: "1rem" }}>
          <Button
            type="primary"
            icon={<FilterOutlined />}
            size="large"
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#64c41aff", // elegant green
              borderColor: "#69c41aff",
              boxShadow: "0 2px 6px rgba(2, 2, 65, 0.3)",
            }}
            onClick={handleSearch}
          >
            Search
          </Button>
        </Col>
      </Row>
    </>
  );
};
